import React, { memo, useMemo } from 'react';
import { motion } from 'framer-motion';

const FloatingShapes = memo(() => {
  const shapes = useMemo(() => [
    { id: 1, color: '#FF6B6B', size: 60, x: '10%', y: '20%', delay: 0 },
    { id: 2, color: '#4ECDC4', size: 50, x: '80%', y: '10%', delay: 0.5 },
    { id: 3, color: '#45B7D1', size: 70, x: '70%', y: '70%', delay: 1 },
    { id: 4, color: '#96CEB4', size: 55, x: '20%', y: '80%', delay: 1.5 },
  ], []);

  const floatingAnimation = useMemo(() => ({
    y: [-20, 20, -20],
    x: [-15, 15, -15],
    transition: {
      duration: 8,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }), []);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {shapes.map((shape) => (
        <motion.div
          key={shape.id}
          className="absolute rounded-full opacity-20 blur-sm"
          style={{
            background: `linear-gradient(135deg, ${shape.color}80, ${shape.color}40)`,
            width: shape.size,
            height: shape.size,
            left: shape.x,
            top: shape.y,
            willChange: 'transform',
          }}
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 0.2, scale: 1 }}
          transition={{ delay: shape.delay, duration: 1 }}
          viewport={{ once: true }}
        />
      ))}
    </div>
  );
});

export default FloatingShapes;
